<template>
  <ElDropdown trigger="hover" @command="saveCSV">
    <span class="csv-link">
      {{ $t('APP.STATS.EXPORT_CSV') }}
      <i class="el-icon-arrow-down el-icon--right" />
    </span>
    <ElDropdownMenu slot="dropdown">
      <ElDropdownItem
        icon="el-icon-download"
        :disabled="primaryDisable"
        command="primary"
      >
        {{ $t('APP.STATS.FIRST_CHART') }}
      </ElDropdownItem>
      <ElDropdownItem
        v-if="showSecondary"
        icon="el-icon-download"
        :disabled="primaryDisable"
        command="secondary"
      >
        {{ $t('APP.STATS.SECOND_CHART') }}
      </ElDropdownItem>
    </ElDropdownMenu>
  </ElDropdown>
</template>

<script>
import FileSaver from 'file-saver';
import packageName from '@/mixins/packageName';
import { Insight } from '@/api/api';
import { mapGetters } from 'vuex';
import { APP_DETAILS } from '@/store/types';

export default {
  name: 'DownloadCsvDropdown',
  mixins: [packageName],
  props: {
    primarySelected: {
      type: Object,
      default: () => ({}),
    },
    secondarySelected: {
      type: Object,
      default: () => ({}),
    },
    range: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({ app: APP_DETAILS }),
    primaryDisable() {
      return !this.primarySelected.type;
    },
    showSecondary() {
      return Boolean(this.secondarySelected.type);
    },
  },
  methods: {
    saveCSV(type) {
      const selectedType =
        type === 'primary' ? this.primarySelected : this.secondarySelected;

      Insight.getCsv({
        haveIAP: this.app.haveIap,
        selectedType,
        range: this.range,
        packageName: this.packageName,
      })
        .then(file => {
          FileSaver.saveAs(file, file.name);
        })
        .catch(({ body: { message } }) => {
          this.$message.error(message);
        });
    },
  },
};
</script>

<style lang="scss">
.csv-link {
  color: $lb-black;
  cursor: pointer;
}
</style>
